import faqData from "constants-lib/seo/faqBasterData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getFaqList = () => {
  const data = faqData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addFaqBagsterJSONLD = () => {
  if (
    window.location.href.includes(`/home/bagster`) &&
    document.getElementById(`faqJSONLD`) === null
  ) {
    const script = faqBagsterJSONLD()
    addJSONLDToHead(script, `faqJSONLD`)
  } else {
    removeElement(`faqJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const faqBagsterJSONLD = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getFaqList(),
  }
  return FaqBagsterTemplate
}
